export default __webpack_public_path__ + "static/media/04_Neocrete_Calculator_Illustrations_Mobile_380x227px-04.3ac5bb74.png";